import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = hash.get("session_id");
    // Strip the session_id from the URL so it is used once and never re-processed.
    window.history.replaceState({}, "", window.location.pathname);
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    loginWithGoogle(sessionId)
      .then(() => navigate("/dashboard", { replace: true }))
      .catch(() => setError(t("auth.googleError")));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-stone-50 text-stone-600" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-rose-600 font-medium">{error}</p>
          <button onClick={() => navigate("/login", { replace: true })} className="mt-4 text-blue-900 underline text-sm" data-testid="auth-callback-retry">{t("nav.login")}</button>
        </div>
      ) : (
        <>
          <Loader2 className="animate-spin text-blue-900" size={28} />
          <p className="mt-3 text-sm">{t("auth.googleProcessing")}</p>
        </>
      )}
    </div>
  );
}
